/**
 * Shared development environment — the default environment file.
 *
 * Used by the default `ng serve` / `ng build` and the `dev` build
 * configuration (the deployed dev build). Served from the shared dev frontend
 * domains (Heron and tenants 1-3), or locally from localhost:4200 — both
 * resolve the tenant — API origin and client web URL — at runtime from the
 * browser origin against `tenant-routes/dev.ts`, whose localhost row points
 * local serving at the shared dev API. To run against a locally running
 * backend instead, use the `local` configuration (scripts/start-local-fullstack.sh).
 */

import { apiUrlsFromOrigin, resolveFrontendRoutes } from '../../tenant-routes/tenant-frontend-routing';
import { DEV_TENANT_ROUTES } from '../../tenant-routes/dev';

const frontendRoutes = resolveFrontendRoutes(window.location.origin, DEV_TENANT_ROUTES);
const apiUrls = apiUrlsFromOrigin(frontendRoutes.apiOrigin);

export const environment = {
  production: false,
  serviceWorkerEnabled: false,

  apiUrl: apiUrls.apiUrl,
  rawApiUrl: apiUrls.rawApiUrl,
  apiVersion: '/v1/',
  conversationApiUrl: 'https://ai-agent-chat-623026858390.europe-west2.run.app/',
  sentryDsn: 'https://451f75ee83bb4469b7fa0817e38af9c6@o4504338104778752.ingest.sentry.io/4505359075246080',
  requestFactFindEnabled: true,
  clientWebUrl: frontendRoutes.clientFrontendUrl,
  tenantId: frontendRoutes.tenantId ?? frontendRoutes.brandId ?? null,
  brandId: frontendRoutes.brandId ?? null,
  introducerTermsAndConditionsUrl:
    'https://storage.googleapis.com/everglades-development.appspot.com/static/Heron Financial Ltd Introducer User Terms - v20250731.pdf',
  swaggerApiLinks: {
    introducerApi: `${apiUrls.apiUrl}servlet/swagger-ui/index.html`
  },
  twenty7tecSourceUrl: 'https://stagingcloud.twenty7tec.com/Sourcing/SourceDetails',
  websocketUrl: 'wss://ai-agent-chat-623026858390.europe-west2.run.app/api/v1/ws'
};
